import { NotificationManager } from 'react-notifications';
import Cookies from 'universal-cookie';
import { SERVER_API } from "../../../config.json"

const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
function tokenAPI() {
    if (tokenUser.token) {
        return tokenUser.token;
    }
    else {
        NotificationManager.error('Mời bạn đăng nhập lại');
    }
}
function* GetDataPermissionFromApi(DataMenu) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/MenuRoles/GetPermission", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMenu)
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}

function* GetDataUserMenuFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/UserMenu/GetUserMenus", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return yield Data.data;
        }
        return yield {}
    }
}
function* DeleteDataUserMenuFromApi(ID) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/UserMenu/Delete?ID=' + ID, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data) {
            NotificationManager.success("Xóa quyền user thành công!");
            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000);
        }
        else {
            NotificationManager.error("Xóa thất bại");
        }
    }
    return yield {};
}
function* SetDataUserMenuFromApi(DataUserMenu) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/UserMenu/Insert", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataUserMenu),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data) {
            NotificationManager.success("Lưu thành công");
            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000);
            // window.location.reload();
        }
        else {
            NotificationManager.error("Lưu thất bại");
        }
    }
    return yield {};
}


//CreateFuntionHygen
export const Api = {
    GetDataPermissionFromApi,
    GetDataUserMenuFromApi,
    DeleteDataUserMenuFromApi,
    SetDataUserMenuFromApi,
    //ExportFuntionHygen
}